import { isUserGivenAlgorithmConfigurationStressWithClusters } from "./user-algorithm-configurations.js";
export class DefaultGraphConversionActionConfiguration {
    static createSpecificAlgorithmConversionAction(name, userGivenAlgorithmConfiguration) {
        switch (name) {
            case "CREATE_GENERALIZATION_SUBGRAPHS":
                return new DefaultGraphConversionActionConfiguration(name, {}, "ALL", false);
            case "TREEIFY":
                return new DefaultGraphConversionActionConfiguration(name, {}, "ALL", false);
            case "CLUSTERIFY":
                return new ClusterifyAction(name, { clusters: null }, "ALL", false);
            case "LAYOUT_CLUSTERS_ACTION":
                if (!isUserGivenAlgorithmConfigurationStressWithClusters(userGivenAlgorithmConfiguration)) {
                    console.error("Using actions for clusters but not using cluster layouting algorithm");
                    return;
                }
                const layoutClustersActionData = {
                    clusterifyAction: null,
                    edgeLength: userGivenAlgorithmConfiguration.stress_edge_len
                };
                return new LayoutClustersAction(name, layoutClustersActionData, "ALL", false);
            case "RESET_LAYOUT":
                return new DefaultGraphConversionActionConfiguration(name, {}, "ALL", false);
            default:
                throw new Error("Forgot to extend createSpecificAlgorithmConversionAction for new conversion");
        }
    }
    constructor(actionName, data, affectedNodes, shouldCreateNewGraph) {
        this.actionName = actionName;
        this.data = data;
        this.affectedNodes = affectedNodes;
        this.shouldCreateNewGraph = shouldCreateNewGraph;
    }
    actionName;
    data;
    affectedNodes;
    shouldCreateNewGraph;
}
export class ClusterifyAction extends DefaultGraphConversionActionConfiguration {
    data = { clusters: null };
}
export class LayoutClustersAction extends DefaultGraphConversionActionConfiguration {
    constructor(actionName, data, affectedNodes, shouldCreateNewGraph) {
        super(actionName, data, affectedNodes, shouldCreateNewGraph);
        this.data = data;
    }
    data = {
        "clusterifyAction": null,
        "edgeLength": 800
    };
}
//# sourceMappingURL=graph-conversion-action.js.map